module.exports = __webpack_public_path__ + "img/e853e35.jpg";